import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.section`
	min-height: 70vh;
	display: flex;
	place-items: center;
	place-content: center;

	.section-wrapper {
		padding: 8em 0;
	}

	.content {
		margin-top: 3em;
		color: #333333;
		font-size: .9em;
	}

	@media all and (max-width: ${vars.mobileL}) {}
`;
